// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"b2ca05bc","707":"6f0c00e6"}[chunkId] + ".chunk.js";
};